export const TOKEN_KEY: string = 'auth-token';
export const USER_KEY: string = 'auth-user';
export const EMAIL_KEY: string = 'auth-email';